import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { NgxMaterialTimepickerTheme } from "ngx-material-timepicker";
import { Dia } from "./utils/agenda-validators";

@Component({
  selector: "app-agenda-form",
  templateUrl: "./agenda-form.component.html",
  styleUrls: ["./agenda-form.component.scss"],
})
export class AgendaFormComponent {
  @Input() agendaForm: FormGroup;
  @Input() diasConConflico: string[] = [];

  readonly dias: ReadonlyArray<{ key: Dia; label: string }> = [
    { key: "lunes",     label: "Lunes" },
    { key: "martes",    label: "Martes" },
    { key: "miercoles", label: "Miercoles" },
    { key: "jueves",    label: "Jueves" },
    { key: "viernes",   label: "Viernes" },
    { key: "sabado",    label: "Sábado" },
    { key: "domingo",   label: "Domingo" },
  ];

  darkTheme: NgxMaterialTimepickerTheme = {
    container: { bodyBackgroundColor: "#ffffff", buttonColor: "#000000" },
    dial: { dialBackgroundColor: "#3434EC" },
    clockFace: {
      clockFaceBackgroundColor: "#EEEEEE",
      clockHandColor: "#05CE7C",
      clockFaceTimeInactiveColor: "#3434EC",
    },
  };

  borrarFecha(fecha: string) {
    this.agendaForm.patchValue({ [fecha]: "" });
  }

  getDiasConConflicto(dia: string): boolean {
    return this.diasConConflico?.includes(dia);
  }
}
